import { render, staticRenderFns } from "./CreateGroupDialog.vue?vue&type=template&id=01429e96&scoped=true&"
import script from "./CreateGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateGroupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGroupDialog.vue?vue&type=style&index=0&id=01429e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01429e96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VContent})
